module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_m_melanistic.dfda1c41.png";